import { render, staticRenderFns } from "./PrivacyDsr.vue?vue&type=template&id=1cf29f99&scoped=true&"
import script from "./PrivacyDsr.vue?vue&type=script&lang=js&"
export * from "./PrivacyDsr.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyDsr.vue?vue&type=style&index=0&id=1cf29f99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf29f99",
  null
  
)

export default component.exports